import { render, staticRenderFns } from "./CustomerHubDisplaySettings.vue?vue&type=template&id=57b85740&scoped=true"
import script from "./CustomerHubDisplaySettings.vue?vue&type=script&lang=js"
export * from "./CustomerHubDisplaySettings.vue?vue&type=script&lang=js"
import style0 from "./CustomerHubDisplaySettings.vue?vue&type=style&index=0&id=57b85740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b85740",
  null
  
)

export default component.exports